export const useSwiperSettings = () => {
    return {
        // Default settings for the smallest screens (mobile-first)
        slidesPerView: 1.2, // Show a bit of the next slide to encourage swiping
        spaceBetween: 16,    // Consistent spacing between slides (in px)
        centeredSlides: false, // Set to true if you want the active slide centered
        grabCursor: true,    // Changes cursor to grab on desktop for better UX
        watchOverflow: true, // Disables Swiper if there are fewer slides than needed

        // Responsive breakpoints
        breakpoints: {
            // When window width is >= 576px
            576: {
                slidesPerView: 2.2,
                spaceBetween: 20,
            },
            // When window width is >= 768px
            768: {
                slidesPerView: 3,
                spaceBetween: 24,
            },
            // When window width is >= 1024px
            1024: {
                slidesPerView: 4,
                spaceBetween: 30,
            },
            // When window width is >= 1280px (optional for larger desktops)
            1280: {
                slidesPerView: 5,
                spaceBetween: 30,
            },
        },

        // Advanced: Calculate breakpoints based on container, not window
        // Uncomment the next line if your Swiper is inside a container with dynamic width
        // breakpointsBase: 'container',
    };
};